import duotone from "icons/duotone"
import EmailIcon from "@mui/icons-material/Email"
import NotificationsIcon from "@mui/icons-material/Notifications"
import DescriptionIcon from "@mui/icons-material/Description"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import ContentPasteIcon from "@mui/icons-material/ContentPaste"
import CardMembershipIcon from "@mui/icons-material/CardMembership"

export const navigations = [
	{
		type: "label",
		label: "Dashboard",
		permission: "dashboard:all",
		icon: CardMembershipIcon,
		hasChild: true
	},
	{
		name: "Trademark",
		path: "/dashboard",
		icon: duotone.LayerGroup,
		permission: "dashboard:all",
		// hasChild: false,
		parent: "Dashboard"
	},
	{
		name: "Patent",
		path: "/dashboard/patent",
		icon: duotone.LayerGroup,
		permission: "dashboard:all",
		// hasChild: false,
		parent: "Dashboard"
	},

	{
		type: "label",
		label: "Contact",
		permission: "contact:label",
		icon: CardMembershipIcon,
		hasChild: true
	},

	{
		name: "Contacts Trademark",
		icon: duotone.PersonCircleCheck,
		path: "/contact",
		permission: "contact:all",
		hasChild: false
	},
	{
		name: "Contacts Patent",
		icon: duotone.PersonCircleCheck,
		path: "/cpatent",
		permission: "contactpatent:all",
		hasChild: false
	},
	{
		name: "Contacts Lain-lain",
		icon: duotone.PersonCircleCheck,
		path: "/cindustri",
		permission: "contactindustri:all",
		hasChild: false
	},

	{
		name: "Master Tarif",
		icon: ReceiptLongIcon,
		path: "/pitem",
		permission: "invoices:all",
		hasChild: false
	},
	{
		name: "Master Kurs",
		icon: ReceiptLongIcon,
		path: "/taxrate",
		permission: "invoices:all",
		hasChild: false
	},
	{
		name: "Message",
		icon: EmailIcon,
		path: "/message",
		permission: "message:all",
		hasChild: false
	},
	{
		name: "Notifikasi",
		icon: NotificationsIcon,
		path: "/notifications",
		permission: "notification:all",
		hasChild: false
	},
	{
		name: "Invoice",
		icon: ReceiptLongIcon,
		path: "/invoices",
		permission: "invoices:all",
		hasChild: false
	},

	{
		name: "Template",
		icon: ContentPasteIcon,
		path: "/templates",
		permission: "templates:all",
		hasChild: false
	},
	{
		type: "label",
		label: "Trademark",
		permission: "trademark:all",
		icon: CardMembershipIcon,
		hasChild: true
	},

	{
		name: "eFiling LN",
		icon: DescriptionIcon,
		path: "/trademark/efiling",
		permission: "filing:all",
		parent: "Trademark"
	},
	{
		name: "eFiling DN",
		icon: DescriptionIcon,
		path: "/trademark/efilingdn",
		permission: "filingdn:all",
		parent: "Trademark"
	},
	{
		name: "Filing Report",
		icon: DescriptionIcon,
		path: "/trademark/filingreport",
		permission: "filingreport:all",
		parent: "Trademark"
	},
	{
		name: "Publikasi",
		icon: DescriptionIcon,
		path: "/trademark/publication",
		permission: "publication:all",
		parent: "Trademark"
	},
	{
		name: "Status LN",
		icon: DescriptionIcon,
		path: "/trademark/status",
		permission: "status:all",
		parent: "Trademark"
	},

	{
		name: "Status DN",
		icon: DescriptionIcon,
		path: "/trademark/statusdn",
		permission: "statusdn:all",
		parent: "Trademark"
	},
	{
		name: "Sertifikat",
		icon: DescriptionIcon,
		path: "/trademark/certificate",
		permission: "certificate:all",
		parent: "Trademark"
	},

	{
		name: "Office Action",
		icon: DescriptionIcon,
		path: "/trademark/officeaction",
		permission: "officeaction:all",
		parent: "Trademark"
	},

	{
		name: "Renewal",
		icon: DescriptionIcon,
		path: "/trademark/renewal",
		permission: "renewal:all",
		parent: "Trademark"
	},
	{
		name: "Recordal",
		icon: DescriptionIcon,
		path: "/trademark/recordal",
		permission: "recordal:all",
		parent: "Trademark"
	},

	{
		name: "Legal",
		icon: DescriptionIcon,
		path: "/trademark/legal",
		permission: "legal:all",
		parent: "Trademark"
	},

	{
		name: "Search",
		icon: DescriptionIcon,
		path: "/trademark/search",
		permission: "search:all",
		parent: "Trademark"
	},

	{
		type: "label",
		label: "Patent",
		permission: "patent:all",
		icon: CardMembershipIcon,
		hasChild: true
	},

	{
		name: "eFiling",
		icon: DescriptionIcon,
		path: "/patent/efiling",
		permission: "patentefiling:all",
		parent: "Patent"
	},
	{
		name: "Formalitas",
		icon: DescriptionIcon,
		path: "/patent/formality",
		permission: "patentformality:all",
		parent: "Patent"
	},
	{
		name: "Publikasi",
		icon: DescriptionIcon,
		path: "/patent/publication",
		permission: "patentpublication:all",
		parent: "Patent"
	},
	{
		name: "Request Substantive",
		icon: DescriptionIcon,
		path: "/patent/substantive",
		permission: "patentsubstantive:all",
		parent: "Patent"
	},
	{
		name: "Office Action",
		icon: DescriptionIcon,
		path: "/patent/officeaction",
		permission: "patentoa:all",
		parent: "Patent"
	},
	{
		name: "Registrasi",
		icon: DescriptionIcon,
		path: "/patent/registration",
		permission: "patentregistration:all",
		parent: "Patent"
	},
	{
		name: "Sertifikat",
		icon: DescriptionIcon,
		path: "/patent/certificate",
		permission: "patentcertificate:all",
		parent: "Patent"
	},
	{
		name: "Renewal",
		icon: DescriptionIcon,
		path: "/patent/renewal",
		permission: "patentrenewal:all",
		parent: "Patent"
	},
	{
		name: "Recordal",
		icon: DescriptionIcon,
		path: "/patent/recordal",
		permission: "patentrecordal:all",
		parent: "Patent"
	},
	{
		name: "Search",
		icon: DescriptionIcon,
		path: "/patent/search",
		permission: "patentsearch:all",
		parent: "Patent"
	},
	{
		name: "PPH",
		icon: DescriptionIcon,
		path: "/patent/pph",
		permission: "patentpph:all",
		parent: "Patent"
	},
	{
		name: "Aspec",
		icon: DescriptionIcon,
		path: "/patent/aspek",
		permission: "patentaspec:all",
		parent: "Patent"
	},
	{
		name: "Voluntary Amandemen",
		icon: DescriptionIcon,
		path: "/patent/voluntary",
		permission: "patentvoluntary:all",
		parent: "Patent"
	},

	{
		type: "label",
		label: "Report",
		permission: "report:all",
		hasChild: true
	},

	{
		name: "AFFA",
		icon: DescriptionIcon,
		path: "/report/affa",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "AKI",
		icon: DescriptionIcon,
		path: "/report/aki",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "ARWANA",
		icon: DescriptionIcon,
		path: "/report/arwana",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "ADASTRA",
		icon: DescriptionIcon,
		path: "/report/adastra",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "AVIA",
		icon: DescriptionIcon,
		path: "/report/avia",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "SEARCH",
		icon: DescriptionIcon,
		path: "/report/search",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "Rekap OA",
		icon: DescriptionIcon,
		path: "/report/oareport",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "Rekap Legal",
		icon: DescriptionIcon,
		path: "/report/legalreport",
		permission: "report:all",
		parent: "Report"
	},
	{
		name: "Report Invoice",
		icon: DescriptionIcon,
		path: "/report/production",
		permission: "report:invoice",
		parent: "Report"
	},

	{
		type: "label",
		label: "Manajemen User",
		permission: "users:all",
		hasChild: true
	},
	{
		name: "User",
		icon: duotone.Accounts,
		path: "/users",
		permission: "users:all",
		parent: "Manajemen User"
	},
	{
		name: "Role",
		icon: duotone.Accounts,
		path: "/role",
		permission: "roles:all",
		parent: "Manajemen User"
	},
	{
		type: "label",
		label: "Master Data",
		permission: "masterdata:all",
		hasChild: true
	},
	{
		name: "AFFA Group",
		icon: duotone.Accounts,
		path: "/master-data/company",
		permission: "company:all",
		parent: "Master Data"
	},
	{
		name: "Konsultant AFFA",
		icon: duotone.Accounts,
		path: "/master-data/consultant",
		permission: "consultant:all",
		parent: "Master Data"
	},
	{
		name: "Divisi",
		icon: duotone.Accounts,
		path: "/master-data/departement",
		permission: "division:all",
		parent: "Master Data"
	},
	{
		name: "Master Task",
		icon: duotone.Accounts,
		path: "/master-data/tasks",
		permission: "tasks:all",
		parent: "Master Data"
	}
]
